<template>
<div class="config-header-text">
    <div class="field is-grouped is-grouped-multiline">
        <div class="control is-expanded">
            <div class="field">
                <LabelWithHelpText>
                    Title
                    <template #help>{{ titleHelpText }}</template>
                </LabelWithHelpText>
                <div class="control">
                    <input
                        :value="title"
                        @input="$emit('update:title', $event.target.value)"
                        class="input"
                        :maxLength="$const.TITLE_MAX_LENGTH"/>
                </div>
            </div>
        </div>
        <div class="control">
            <div class="field">
                <label class="label">Font Size</label>
                <div class="control">
                    <input
                        :value="titleFontSize"
                        @input="$emit('update:titleFontSize', Number($event.target.value))"
                        class="input "
                        type="number"
                        min="12"
                        max="50"
                        placeholder="32"
                        required/>
                </div>
            </div>
        </div>
    </div>
    <FontInput
        :value="titleFontUrl"
        @input="$emit('update:titleFontUrl', $event)"
        :fontLoadingState="titleFontLoadingState">
        <template #label>Title Font URL</template>
    </FontInput>
    <GradientInput
        :value="titleGradient"
        @input="$emit('update:titleGradient', $event)"/>
</div>
</template>

<script>
import { mapState } from 'vuex'

import FontInput from '@/font-loader/FontInput'
import GradientInput from '@/components/config/GradientInput'

export default {
    name: 'ConfigHeaderText',
    props: {
        title: String,
        titleFontSize: Number,
        titleGradient: String,
        titleFontUrl: String,
    },
    data: () => ({
        gradientPlaceholder: 'background: linear-gradient(90deg, rgba(245,124,0,1) 0%, rgba(252,70,107,1) 100%);',
        gradientToolUrl: 'https://cssgradient.io/',
        premadeGradientsUrl: 'https://gradienthunt.com/popular',
        demoUrl: 'https://youtu.be/vf6c2w86WB4',
    }),
    computed: {
        ...mapState(['titleFontLoadingState']),
        titleHelpText: vm => `${vm.title.length}/${vm.$const.TITLE_MAX_LENGTH}`,
    },
    components: {
        FontInput,
        GradientInput
    }
}
</script>

<style lang="scss" scoped>
.config-header-text > * {
    margin-bottom: 1rem !important;
}
</style>
